import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../API/auth.service';

export const adminGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const user = authService.getUser();

  if (!user) {
    router.navigate(['/login']);
    return false;
  }

  if (user.userRoles.filter(role => role.role === 'CCL_ADMIN' || role.role === 'CCL_OPS').length > 0) {
    return true;
  }

  router.navigate(['/']);
  return false;
};
